import Swiper, { Autoplay, EffectFade } from 'swiper';

export default function initHeaderHome(): void {
    const $headerHomeContainer = document.querySelectorAll<HTMLElement>('.js-header-home');

    $headerHomeContainer.forEach($container => {
        new HeaderHome($container);
    });
}

class HeaderHome {
    $el: HTMLElement | null | undefined;
    $slider: HTMLElement | null | undefined;
    swiper: Swiper | null = null;


    constructor($el: HTMLElement | null) {
        this.$el = $el;
        this.$slider = $el?.querySelector('.slider-home');
        this.init();
    }

    init(): void {
        this.initSlider();
    }

    initSlider() {
        if (this.$slider) {
            this.swiper = new Swiper(this.$slider, {
                modules: [Autoplay, EffectFade],
                effect: 'fade',
                loop: true,
                speed: 1000,
                autoplay: {
                    delay: 2500,
                },
                slidesPerView: 1,
            });
        }
    }
}